import Attribute from "./Attribute";

export default class CalendarEvent {
    public startingDate: Date = new Date();
    public endingDate: Date = new Date();
    public color: string = "red";
    public label: string = "";
    public worlds: string[] = [];
}

export function ConvertCalendarEventToAttribute(event: CalendarEvent): Attribute {
    const result = new Attribute();

    result.dates = [];
    const thisDate = new Date(event.startingDate.getTime());
    while (thisDate <= event.endingDate) {
        result.dates.push(new Date(thisDate.getTime()));
        thisDate.setDate(thisDate.getDate() + 1);
    }

    result.bar = event.color;
    result.popover.label = event.label;
    return result;
}
